export default __webpack_public_path__ + "static/media/collaborative.a1a4df5e.svg";